// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ExemptionTrackingTable_LifetimeExclusionEventFragment } from '../ExemptionTrackingTable/graphql/ExemptionTrackingTable.generated';
import { gql } from '@apollo/client';
import { ExemptionTrackingTable_LifetimeExclusionEventFragmentDoc } from '../ExemptionTrackingTable/graphql/ExemptionTrackingTable.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientDetailsGiftingPage_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, gstExclusionUsed: CurrencyUSD, displayName: string, lifetimeExclusionUsed: CurrencyUSD, currentAnnualExclusionUsed: CurrencyUSD, totalAnnualExclusionUsed: CurrencyUSD, remainingStateExemption: CurrencyUSD, stateExemptionUsed: CurrencyUSD, totalStateExemption: CurrencyUSD, address?: { __typename?: 'Address', id: string, stateCode: string } | null, dsue?: { __typename?: 'DSUEPortability', id: string, amount: CurrencyUSD, eventDate: Time } | null };

export type ClientDetailsGiftingPage_HouseholdFragment = { __typename?: 'Household', id: string, possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile' }
    & ClientDetailsGiftingPage_ClientProfileFragment
  )> };

export type ClientDetailsGiftingPageQueryVariables = Types.Exact<{
  householdWhere?: Types.InputMaybe<Types.HouseholdWhereInput>;
  lifetimeExclusionEventsWhere?: Types.InputMaybe<Types.LifetimeExclusionEventWhereInput>;
}>;


export type ClientDetailsGiftingPageQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household', id: string }
        & ClientDetailsGiftingPage_HouseholdFragment
      ) | null } | null> | null }, lifetimeExclusionEvents: { __typename?: 'LifetimeExclusionEventConnection', totalCount: number, edges?: Array<{ __typename?: 'LifetimeExclusionEventEdge', node?: (
        { __typename?: 'LifetimeExclusionEvent', id: string }
        & ExemptionTrackingTable_LifetimeExclusionEventFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientDetailsGiftingPage: 'ClientDetailsGiftingPage' as const
  },
  Fragment: {
    ClientDetailsGiftingPage_ClientProfile: 'ClientDetailsGiftingPage_ClientProfile' as const,
    ClientDetailsGiftingPage_Household: 'ClientDetailsGiftingPage_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientDetailsGiftingPage_ClientProfileFragmentDoc = gql`
    fragment ClientDetailsGiftingPage_ClientProfile on ClientProfile {
  id
  gstExclusionUsed
  displayName
  lifetimeExclusionUsed
  currentAnnualExclusionUsed
  totalAnnualExclusionUsed
  remainingStateExemption
  stateExemptionUsed
  totalStateExemption
  address {
    id
    stateCode
  }
  dsue {
    id
    amount
    eventDate
  }
}
    `;
export const ClientDetailsGiftingPage_HouseholdFragmentDoc = gql`
    fragment ClientDetailsGiftingPage_Household on Household {
  id
  possiblePrimaryClients {
    ...ClientDetailsGiftingPage_ClientProfile
  }
}
    ${ClientDetailsGiftingPage_ClientProfileFragmentDoc}`;
export const ClientDetailsGiftingPageDocument = gql`
    query ClientDetailsGiftingPage($householdWhere: HouseholdWhereInput, $lifetimeExclusionEventsWhere: LifetimeExclusionEventWhereInput) {
  households(where: $householdWhere) {
    edges {
      node {
        id
        ...ClientDetailsGiftingPage_Household
      }
    }
  }
  lifetimeExclusionEvents(
    where: $lifetimeExclusionEventsWhere
    orderBy: {field: event_date, direction: DESC}
  ) {
    edges {
      node {
        id
        ...ExemptionTrackingTable_LifetimeExclusionEvent
      }
    }
    totalCount
  }
}
    ${ClientDetailsGiftingPage_HouseholdFragmentDoc}
${ExemptionTrackingTable_LifetimeExclusionEventFragmentDoc}`;

/**
 * __useClientDetailsGiftingPageQuery__
 *
 * To run a query within a React component, call `useClientDetailsGiftingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDetailsGiftingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDetailsGiftingPageQuery({
 *   variables: {
 *      householdWhere: // value for 'householdWhere'
 *      lifetimeExclusionEventsWhere: // value for 'lifetimeExclusionEventsWhere'
 *   },
 * });
 */
export function useClientDetailsGiftingPageQuery(baseOptions?: Apollo.QueryHookOptions<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>(ClientDetailsGiftingPageDocument, withFetchPolicyContext(options));
      }
export function useClientDetailsGiftingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>(ClientDetailsGiftingPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientDetailsGiftingPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>(ClientDetailsGiftingPageDocument, withFetchPolicyContext(options));
        }
export type ClientDetailsGiftingPageQueryHookResult = ReturnType<typeof useClientDetailsGiftingPageQuery>;
export type ClientDetailsGiftingPageLazyQueryHookResult = ReturnType<typeof useClientDetailsGiftingPageLazyQuery>;
export type ClientDetailsGiftingPageSuspenseQueryHookResult = ReturnType<typeof useClientDetailsGiftingPageSuspenseQuery>;
export type ClientDetailsGiftingPageQueryResult = Apollo.QueryResult<ClientDetailsGiftingPageQuery, ClientDetailsGiftingPageQueryVariables>;